export default [{
  path: 'source-banner',
  name: 'source-banner',
  component: () => import('./banner'),
  meta: {
    code: '/resource/resource.htm'
  }
}, {
  path: 'index-recommend-manage',
  name: 'index-recommend-manage',
  component: () => import('./index-recommend-manage'),
  meta: {
    code: '/resource/sysHomePageResource.htm'
  }
}, {
  path: 'source-time-line',
  name: 'source-time-line',
  component: () => import('./time-line'),
  meta: {
    code: '/resource/articleTimeLine.htm'
  }
}, {
  path: 'source-zixun-pool-zygj',
  name: 'source-zixun-pool-zygj',
  component: () => import('./housekeeper-information'),
  meta: {
    code: '/resource/agentAdminArticlePool.htm'
  }
}, {
  path: 'source-zixun-publish-zygj',
  name: 'source-zixun-publish-zygj',
  component: () => import('./housekeeper-information-publish'),
  meta: {
    code: '/resource/agentAdminArticle.htm'
  }
}, {
  path: 'source-zixun-pool-zyk',
  name: 'source-zixun-pool-zyk',
  component: () => import('./zhiyaoke-information'),
  meta: {
    code: '/resource/articlePool.htm'
  }
}, {
  path: 'source-zixun-publish-zyk',
  name: 'source-zixun-publish-zyk',
  component: () => import('./zhiyaoke-information-publish'),
  meta: {
    code: '/resource/article.htm'
  }
}, {
  path: 'source-activity',
  name: 'source-activity',
  component: () => import('./activity'),
  meta: {
    code: '/activity.htm'
  }
}, {
  path: 'source-all-message',
  name: 'source-all-message',
  component: () => import('./message/source-message-all'),
  meta: {
    code: '/sms/batch.htm'
  }
}, {
  path: 'source-message-info',
  name: 'source-message-info',
  component: () => import('./message/source-message'),
  meta: {
    code: '/resource/notify.htm'
  }
}, {
  path: 'source-system-info',
  name: 'source-system-info',
  component: () => import('./info/system'),
  meta: {
    code: '/msg/msgManager.htm'
  }
}, {
  path: 'source-zhiyao-info',
  name: 'source-zhiyao-info',
  component: () => import('./info/zhiyao'),
  meta: {
    code: '/msg/msgZyManager.htm'
  }
}, {
  path: 'source-service-info',
  name: 'source-service-info',
  component: () => import('./info/service'),
  meta: {
    code: '/msg/msgFwManager.htm'
  }
}, {
  path: 'source-tag-setting',
  name: 'source-tag-setting',
  component: () => import('./setting/tag-setting'),
  meta: {
    code: '/resource/articleNavigate.htm'
  }
}, {
  path: 'public-info',
  name: 'public-info',
  component: () => import('./info/public/index.vue')
}, {
  path: 'discount-grantRecord',
  name: 'discount-grantRecord',
  component: () => import('./discount/grantRecord/index.vue')
}, {
  path: 'discount-list',
  name: 'discount-list',
  component: () => import('./discount/ticket-list/index.vue')
}, {
  path: 'source-zixun-information', // 资讯站资讯
  name: 'source-zixun-information',
  component: () => import('./zixun-information'),
}, {
  path: 'source-city-community', // 同城社群
  name: 'source-city-community',
  component: () => import('./city-community'),
}, {
  path: 'source-invit-compass', // 招聘指南
  name: 'source-invit-compass',
  component: () => import('./invit-compass'),
}, {
  path: 'source-spell-group',
  name: 'source-spell-group',
  component: () => import('./spell-group')
}];



// WEBPACK FOOTER //
// ./src/views/source/index.route.js